import { DSModal } from "@components/design-system/organisms";

export function SilenceDetectedModal({
  shouldShowSilenceDetectedModal,
  setShouldShowSilenceDetectedModal,
}) {
  return (
    <DSModal
      isOpen={shouldShowSilenceDetectedModal}
      onClose={() => setShouldShowSilenceDetectedModal(false)}
      title="No Audio Detected"
      dataTestId="silence-detected-modal"
      actions={[
        {
          label: "Ok",
          variant: "primary",
          onClick: () => setShouldShowSilenceDetectedModal(false),
        },
      ]}
    >
      <h5>
        We&apos;ve detected no audio within the first minute of this
        recording. Your recording is still in progress, but if this is
        not expected you may want to check your microphone and sound
        settings.
      </h5>
    </DSModal>
  );
}
